const DialogColors = {
  DEFAULT: 'gray',
  PRIMARY: 'primary',
  SUCCESS: 'success',
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
};

const ButtonColors = {
  DEFAULT: 'gray',
  PRIMARY: 'primary',
  SUCCESS: 'success',
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
};

const ButtonColorsDefault = {
  accept: null,
  decline: null,
};

const ToastX = {
  LEFT: 'left',
  RIGHT: 'right',
  CENTER: '',
};

const ToastY = {
  TOP: 'top',
  BOTTOM: 'bottom',
};

const ToastMode = {
  MULTILINE: false,
  VERTICAL: false,
};

const DialogTypes = {
  WARNING: 'warning',
  ERROR: 'error',
  SUCCESS: 'success',
  INFO: 'info',
  PRIMARY: 'primary',
};

const DialogTestIds = {
  WARNING_DIALOG: 'warning-dialog',
  WARNING_DIALOG_HEADER: 'warning-dialog-header',
  WARNING_ALERT_DIALOG: 'warning-alert-dialog',
  DIALOG_ACCEPT_BUTTON: 'warning-dialog-accept-button',
  DIALOG_DECLINE_BUTTON: 'warning-dialog-decline-button',
  DIALOG_ACCEPT_BUTTON_ALERT: 'warning-dialog-accept-button-alert',
};

export {
  DialogColors, ToastX, ToastY, ToastMode, ButtonColorsDefault, ButtonColors, DialogTypes, DialogTestIds,
};
